import axios from 'axios'
import toast from 'react-hot-toast'

import jwtDefaultConfig from './jwtDefaultConfig'

export default class JwtService {
  jwtConfig = { ...jwtDefaultConfig }

  constructor(jwtOverrideConfig) {
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }
    this.axios = axios.create()

    this.axios.interceptors.request.use(
      config => {
        const accessToken = this.getToken()

        if (accessToken) {
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
        }

        return config
      },
      error => Promise.reject(error)
    )

    this.axios.interceptors.response.use(
      response => {
        const notifications = response?.data?.notifications

        if (response?.data?.success === false && Array.isArray(notifications)) {
          const message = notifications
            .map(item => `${item.property}: ${item.message}`)
            .join('\n')

          if (message) toast.error(message, { position: 'top-center' })
        }

        return response
      },
      error => {
        const { config, response } = error
        const isLoginRequest = config?.url === this.jwtConfig.loginEndpoint

        if (response?.status === 401 && !isLoginRequest) {
          this.clearSession()

          if (window.location.pathname !== '/login') {
            window.location.assign('/login')
          }
        }

        if (response?.status === 413) {
          toast.error('O arquivo enviado excede o tamanho permitido.', {
            position: 'top-center'
          })
        } else if (response?.status >= 500) {
          toast.error('Não foi possível concluir a operação. Tente novamente.', {
            position: 'top-center'
          })
        }

        return Promise.reject(error)
      }
    )
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName)
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  clearSession() {
    localStorage.removeItem('userData')
    localStorage.removeItem(this.jwtConfig.storageTokenKeyName)
    localStorage.removeItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  login(args) {
    return this.axios.post(this.jwtConfig.loginEndpoint, args)
  }

  register(data) {
    return this.axios.post(this.jwtConfig.registerEndpoint, data)
  }

  post(url, data) {
    return this.axios.post(this.jwtConfig.apiEndpoint + url, data)
  }

  put(url, data) {
    return this.axios.put(this.jwtConfig.apiEndpoint + url, data)
  }

  delete(url) {
    return this.axios.delete(this.jwtConfig.apiEndpoint + url)
  }

  get(url, args) {
    const config = args || {}

    return this.axios.get(this.jwtConfig.apiEndpoint + url, {
      ...config,
      params: {
        ...config.params,
        _: Date.now()
      }
    })
  }

  refreshToken() {
    return this.axios.post(this.jwtConfig.refreshEndpoint, {
      refreshToken: this.getRefreshToken()
    })
  }
}
